import { eurosParAn } from '@/domaine/Montant'

export const SEUIL_PROFESSIONNALISATION = eurosParAn(23_000)
